import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../../Utils/toastContext";
import AddUserPopup from "../../../Components/add-joint-accounts/Add-User-Popup";
import { useDispatch, useSelector } from "react-redux";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import AddressAutocomplete from "../../../Components/addressInput/address-input";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDropdownWithFetch from "../../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import { debounce } from "lodash";
import countriesData from "../../../Data/CountryCodes.json";
import DocumentPreview from "../../Create-Investment/documentpreview";
import {
  setStepStatus,
  setRejectedFields,
  setIndividualAccountType,
} from "../../../Redux/store/onboardingFormSlice";
import ReviewPopup from "../../../Components/onboarding/review-popup";
import LabelWithStatus from "../../../Components/onboarding/label-with-status";
import StatusButton from "../../../Components/onboarding/status-button";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";

const PersonalInfo = ({ setCurrentStep }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const applicationType = useSelector(
    (state) => state.accountType.applicationType,
  );
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const isInvitee = useSelector((state) => state.user.isInvitee);
  const isInviteeDirector = useSelector(
    (state) => state.user.isInviteeDirector,
  );
  const stepStatus = useSelector((state) => state.form.stepStatus);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [accountType, setAccountType] = useState(null);
  const [jointAccountUser, setJointAccountUser] = useState("");
  const [accountTypeLabel, setAccountTypeLabel] = useState("");
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [advisorId, setAdvisorId] = useState("");
  const [isAdvisorExist, setIsAdvisorExist] = useState(false);
  const [advisorName, setAdvisorName] = useState("");
  const [fullName, setfullName] = useState("");
  const [profilePayloadFile, setProfilePayloadFile] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [firstName, setfirstName] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [lastName, setLastName] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [middleName, setMiddleName] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [formerNames, setFormerNames] = useState({
    verification_id: null,
    value: [],
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [accountTypeData, setAccountTypeData] = useState([]);
  const [newFormerName, setFormerName] = useState("");
  const [Dob, setDob] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currencyData, setCurrencyData] = useState([]);
  const [expectedAmountData, setExpectedAmountData] = useState([]);
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedAccountType, setpreselectedAccountType] = useState({});
  const [toCurrency, setToCurrency] = useState({
    verification_id: null,
    value: {
      id: 2,
      name: "AUD",
      symbol: "$",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [capturedFile, setCapturedFile] = useState(null);

  const [jointAccountUserLabel, setJointAccountUserLabel] = useState("");
  const [apIAddress, setApIAddress] = useState("");

  const [countryCodeData, setCountryCodeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 14,
    label: "Australia",
  });
  const [preselectedInevstmentAmount, setpreselectedInevstmentAmount] =
    useState({});
  const [preselectedJointAccountUser, setPreselectedJointAccountUser] =
    useState({});
  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: "Australia",
      risk_factor: "low",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCountry, setRedCountry] = useState(null);
  const [redAddress, setRedAddress] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);
  const [investmentAmountText, setInvestmentAmountText] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
  });
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState("/avatar.svg");
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [fileAvailable, setFileAvailable] = useState(false);
  const [fileAttorneyPath, setfileAttorneyPath] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [stream, setStream] = useState(null);
  const [animateCamera, setAnimateCamera] = useState(false);
  const { showToast } = useToast();
  const [jointAccountId, setJointAccountId] = useState(null);
  const [isCheckedSecond, setIsCheckedSecond] = useState(false);
  const [members, setMembers] = useState([]);
  const [signatory, setSignatory] = useState("no");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [actualData, setactualData] = useState([]);
  const [jointAccountUsersData, setJointAccountUsersData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [nameFromBirth, setNameFromBirth] = useState({
    verification_id: null,
    value: true,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const clientIdRedux = useSelector((state) => state.user.clientId);
  const userStatus = useSelector((state) => state.user.userStatus);

  const [clientId, setClientId] = useState(clientIdRedux);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [countries, setCountries] = useState([]);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const fieldLabelMap = {
    account_type_id: "Account Type",
    applicant_country_id: "Applicant's Country",
    profile_picture_file: "Profile Picture",
    first_name: "First Name",
    last_name: "Last Name",
    middle_name: "Middle Name",
    is_birth_name: "Is this your name from birth?",
    former_names: "Customer's Former Name(s)",
    date_of_birth: "Date Of Birth",
    expected_investment_amount: "Expected Investment Amount",
    default_currency_id: "Default Investment Currency",
    social_security_number: "Social Security Number",
    address_id: "Residential Address",
    joint_account_invitees: "Joint Account Member(s)",
    power_of_attorney_file: "Power of Attorney",
  };

  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {};
  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        redAddress.value.country &&
          redAddress.value.country.name &&
          redAddress.value.country.name !== ""
          ? redAddress.value.country.name
          : redAddress.value.country,
        redAddress.value.state &&
          redAddress.value.state.name &&
          redAddress.value.state.name !== ""
          ? redAddress.value.state.name
          : redAddress.value.state,
        redAddress.value.city &&
          redAddress.value.city.name &&
          redAddress.value.city.name !== ""
          ? redAddress.value.city.name
          : redAddress.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAccountTypes = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/user-types/${applicationType}/accounts`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setAccountTypeData(AccountData);
        setpreselectedAccountType(AccountData[0]);
        setAccountType(AccountData[0].value);
        setAccountTypeLabel(AccountData[0].label);
        dispatch(setIndividualAccountType(AccountData[0].value));
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountTypeData([]);
          setpreselectedAccountType({});
          dispatch(setIndividualAccountType(null));
          setAccountTypeLabel("");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setAccountTypeData([]);
      setpreselectedAccountType({});
      dispatch(setIndividualAccountType(null));
      setAccountTypeLabel("");
    } finally {
    }
  };
  const getInvestmentAmount = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/personal-information/expected-investment-amounts`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.expected_investment_amounts.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setExpectedAmountData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountTypeData([]);
          setpreselectedAccountType({});
          setAccountType(null);
          setAccountTypeLabel("");
          dispatch(setIndividualAccountType(null));
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setAccountTypeData([]);
      setpreselectedAccountType({});
      setAccountType(null);
      setAccountTypeLabel("");
      dispatch(setIndividualAccountType(null));
    } finally {
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            symbol: profile.symbol,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/countries?size=250`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            risk_factor: profile.risk_factor,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/countries?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
          risk_factor: item.risk_factor,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/personal-information/individual/verification/preview`,
      );

      if (response.status == 200) {
        if (response.data) {
          setAccountType(response.data.account_type.value.id);
          dispatch(
            setIndividualAccountType(response.data.account_type.value.id),
          );
          setAccountTypeLabel(response.data.account_type.value.name);
          setpreselectedAccountType({
            value: response.data.account_type.value.id,
            label: response.data.account_type.value.name,
          });
          setfirstName(response.data.first_name);
          setLastName(response.data.last_name);
          setMiddleName(response.data.middle_name);
          setNameFromBirth(response.data.is_birth_name);
          setFormerNames(response.data.former_names);
          setDob(response.data.date_of_birth);
          setCountryCode(response.data.applicant_country);
          setpreselectedCountryCode({
            value: response.data.applicant_country.value.id,
            label: response.data.applicant_country.value.name,
          });
          setApIAddress(response.data.address.value);
          setRedAddress(response.data.address);
          setInvestmentAmountText(response.data.expected_investment_amount);
          let investmentAmount = expectedAmountData.filter(
            (item) =>
              item.label == response.data.expected_investment_amount.value,
          );
          setpreselectedInevstmentAmount({
            value: investmentAmount[0].value,
            label: response.data.expected_investment_amount.value,
          });
          setToCurrency(response.data.default_currency);
          setpreselectedCurrency({
            value: response.data.default_currency.value.id,
            label: response.data.default_currency.value.name,
          });
          setSocialSecurityNumber(response.data.social_security_number);
          setProfilePayloadFile(response.data.profile_picture_file);
          if (
            response.data.joint_account &&
            response.data.joint_account.invitations.length > 0
          ) {
            const transformed = response.data.joint_account.invitations.map(
              (item) => {
                const apiAddress = item.address.value;

                // Safely transform backend address to the structure your component expects
                const formattedAddress = apiAddress
                  ? {
                      full: apiAddress.google_address || "",
                      street: apiAddress.street_number
                        ? `${apiAddress.street_number} ${
                            apiAddress.street_name || ""
                          }`.trim()
                        : apiAddress.address_line_1 || "",
                      route: apiAddress.address_line_2 || "",
                      city: apiAddress.city?.name || "",
                      state: apiAddress.state?.name || "",
                      country: apiAddress.country?.name || "",
                      zip: apiAddress.postal_code || "",
                    }
                  : {
                      full: "",
                      street: "",
                      route: "",
                      city: "",
                      state: "",
                      country: "",
                      zip: "",
                    };

                return {
                  firstName: item.invitee_first_name || "",
                  lastName: item.invitee_last_name || "",
                  dob: item.invitee_date_of_birth || "", // not provided
                  email: item.invitee_email || "",
                  countryCode: item.invitee_country_code || "AU(+61)",
                  mobile: item.invitee_mobile_number || "",
                  address: formattedAddress,
                  accountType: "individual",
                  errors: {
                    email: "",
                    mobile: "",
                  },
                };
              },
            );

            setMembers(transformed);
            let jointUserSoleSignatory =
              response.data.joint_account.invitations.filter(
                (item) => item.proposed_is_sole_signatory.value == true,
              );
            if (jointUserSoleSignatory.length > 0) {
              setJointAccountUser(
                jointUserSoleSignatory[0].invitee_email.value,
              );
              setJointAccountUserLabel(
                jointUserSoleSignatory[0].invitee_first_name.value +
                  " " +
                  jointUserSoleSignatory[0].invitee_last_name.value,
              );
              setPreselectedJointAccountUser({
                value: jointUserSoleSignatory[0].invitee_email.value,
                label:
                  jointUserSoleSignatory[0].invitee_first_name.value +
                  " " +
                  jointUserSoleSignatory[0].invitee_last_name.value,
              });
            } else {
              setJointAccountUser("me");
              setJointAccountUserLabel("Myself");
              setPreselectedJointAccountUser({
                value: "me",
                label: "Myself",
              });
            }
            setJointAccountId(response.data.joint_account.id.value);
          }
          setIsCheckedSecond(response.data.is_managing_member.value);
          setSignatory(
            response.data.is_any_sole_signatory.value == true ? "yes" : "no",
          );
          setPreview(
            response.data.profile_picture_file.value.presigned_url == ""
              ? "/avatar.svg"
              : response.data.profile_picture_file.value.presigned_url,
          );
          setfileAttorneyPath(response.data.power_of_attorney_file);
          setFileAttorney(response.data.power_of_attorney_file.value);
        } else {
          setAccountType(null);
          dispatch(setIndividualAccountType(null));
          setAccountTypeLabel("");
          setpreselectedAccountType({});
          setfirstName({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setLastName({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setMiddleName({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setNameFromBirth({
            verification_id: null,
            value: true,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFormerNames({
            verification_id: null,
            value: [],
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setDob({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCountryCode({
            verification_id: null,
            value: {
              id: 14,
              name: "Australia",
              risk_factor: "low",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCountryCode({
            value: 14,
            label: "Australia",
          });
          setApIAddress("");
          setRedAddress({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setInvestmentAmountText({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
          });
          setpreselectedInevstmentAmount({});
          setToCurrency({
            verification_id: null,
            value: {
              id: 2,
              name: "AUD",
              symbol: "$",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCurrency({
            value: 2,
            label: "AUD",
          });
          setSocialSecurityNumber({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setProfilePayloadFile({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setMembers([]);
          setJointAccountUser("");
          setJointAccountUserLabel("");
          setPreselectedJointAccountUser({});
          setJointAccountId(null);
          setIsCheckedSecond(false);
          setSignatory("no");
          setPreview("/avatar.svg");
          setfileAttorneyPath({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileAttorney(null);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getPrefilled = async () => {
    try {
      const response = await GetAPIcalls(
        isInvitee
          ? `/v1/onboarding/personal-information/individual/invitee/prefill`
          : `/v1/onboarding/corporate-director/personal-information/prefill`,
      );

      if (response.status == 200) {
        setAccountType(response.data.account_type.value.id);
        dispatch(setIndividualAccountType(response.data.account_type.value.id));
        setAccountTypeLabel(response.data.account_type.value.name);
        setpreselectedAccountType({
          value: response.data.account_type.value.id,
          label: response.data.account_type.value.name,
        });
        setfirstName(response.data.first_name);
        setLastName(response.data.last_name);
        setMiddleName(response.data.middle_name);
        setNameFromBirth(response.data.is_birth_name);
        setFormerNames(response.data.former_names);
        setDob(response.data.date_of_birth);

        setApIAddress(response.data.address.value);
        setRedAddress(response.data.address);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleNameFromBirth = (e) => {
    const value = e.target.value === "true"; // convert string → boolean
    setNameFromBirth({
      ...nameFromBirth,
      value: value,
    });
  };
  const handleDeleteFile = () => {
    setFileAttorney(null);
    setFileAvailable(false);
    setfileAttorneyPath({
      verification_id: null,
      value: "",
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const addMember = () => {
    const fieldTemplate = {
      verification_id: null,
      value: "",
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    };

    setMembers((prev) => [
      ...prev,
      {
        firstName: { ...fieldTemplate },
        lastName: { ...fieldTemplate },
        dob: { ...fieldTemplate },
        email: { ...fieldTemplate },
        countryCode: { ...fieldTemplate, value: "AU(+61)" },
        mobile: { ...fieldTemplate },
        address: { ...fieldTemplate },
        accountType: { ...fieldTemplate, value: "individual" },
        errors: { email: "", mobile: "" },
      },
    ]);
  };

  const removeMember = (index) => {
    setMembers((prev) => prev.filter((_, i) => i !== index));
  };
  const checkFields = () => {
    const validations = [
      {
        condition: !profilePayloadFile.value,
        message: "Please upload profile picture",
      },
      {
        condition: !firstName.value,
        message: "Please enter a valid first name",
      },
      { condition: !lastName.value, message: "Please enter a valid last name" },
      {
        condition: !redAddress.value || !redCountry,
        message: "Please enter a valid residential address",
      },
      { condition: !Dob.value, message: "Please enter a valid date of birth" },
      {
        condition: !investmentAmountText.value,
        message: "Please select expected investment amount",
      },
      { condition: !countryCode.value.id, message: "Please select country" },
      {
        condition:
          nameFromBirth.value === false && formerNames.value.length === 0,
        message: "Please enter at least one former name",
      },
      {
        condition:
          accountType !== 1 &&
          accountType !== 5 &&
          (members.length === 0 ||
            (members[0]?.firstName?.value === "" &&
              members[0]?.lastName?.value === "" &&
              members[0]?.email?.value === "")),
        message: "Please add at least one joint account member",
      },
      {
        condition:
          accountType !== 1 &&
          accountType !== 5 &&
          signatory === "yes" &&
          !fileAttorneyPath.value,
        message: "Please upload Power of Attorney file",
      },
      {
        condition:
          accountType !== 1 &&
          accountType !== 5 &&
          signatory === "yes" &&
          !jointAccountUser,
        message: "Please select sole signatory",
      },
    ];

    for (const { condition, message } of validations) {
      if (condition) {
        showToast(message, "error");
        return true;
      }
    }

    return false;
  };
  const checkFieldsJA = () => {
    const validations = [
      {
        condition: !profilePayloadFile.value,
        message: "Please upload profile picture",
      },
      {
        condition: !firstName.value,
        message: "Please enter a valid first name",
      },
      { condition: !lastName.value, message: "Please enter a valid last name" },
      {
        condition: !redAddress.value || !redCountry,
        message: "Please enter a valid residential address",
      },
      { condition: !Dob.value, message: "Please enter a valid date of birth" },
      {
        condition: !investmentAmountText.value,
        message: "Please select expected investment amount",
      },
      { condition: !countryCode.value.id, message: "Please select country" },
      {
        condition:
          nameFromBirth.value === false && formerNames.value.length === 0,
        message: "Please enter at least one former name",
      },
    ];

    for (const { condition, message } of validations) {
      if (condition) {
        showToast(message, "error");
        return true;
      }
    }

    return false;
  };
  const handleContinue = async (isFinal) => {
    if (!isInvitee && !isInviteeDirector && !checkFields()) {
      setLoading(true);
      handlesave(isFinal);
    }
    if ((isInvitee || isInviteeDirector) && !checkFieldsJA()) {
      setLoading(true);
      handlesave(isFinal);
    }
  };

  const updateMember = (index, key, newValue, newErrors = null) => {
    setMembers((prev) =>
      prev.map((member, i) => {
        if (i !== index) return member;

        // If the field exists (like firstName, email, etc.)
        if (
          member[key] &&
          typeof member[key] === "object" &&
          "value" in member[key]
        ) {
          return {
            ...member,
            [key]: {
              ...member[key],
              value: newValue,
            },
            errors: newErrors !== null ? newErrors : member.errors,
          };
        }

        // If updating a simple property like 'errors'
        return {
          ...member,
          [key]: newValue,
        };
      }),
    );
  };
  const handleSelectAccountType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setAccountType(selectedOption.value);
    dispatch(setIndividualAccountType(selectedOption.value));
    setAccountTypeLabel(selectedOption.label);
    setMembers([]);
  };

  const handleSelectJointAccountUser = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setJointAccountUser(selectedOption.value);
    setJointAccountUserLabel(selectedOption.label);
  };
  const handleSelectInvestmentAmount = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setInvestmentAmountText({
      ...investmentAmountText,
      value: selectedOption.label,
    });
  };

  const handleUploadFile = useCallback(
    debounce(async (e, file) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UploadCSVApi(capturedFile);
        if (response.status == "200") {
          toastMessage = {
            message: "Profile picture uploaded successfully",
            type: "success",
          };
          handleCloseCamera();
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [capturedFile], // Dependencies
  );
  const handleAddFormerName = (e) => {
    if (e.key === "Enter" && newFormerName.trim() !== "") {
      setFormerNames((prev) => {
        const existingValues = Array.isArray(prev?.value)
          ? prev.value
          : prev?.value
            ? [prev.value]
            : [];

        return {
          ...prev,
          value: [...existingValues, newFormerName.trim()],
        };
      });

      setFormerName(""); // clear input
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames((prev) => ({
      ...prev,
      value: prev.value.filter((_, index) => index !== indexToRemove),
    }));
  };
  const handleSelectToCurrency = (selectedOption) => {
    setToCurrency({
      ...toCurrency,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleSelectCountryCode = (selectedOption) => {
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        risk_factor: selectedOption.risk_factor,
      },
    });
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await UploadCSVApi(file);
        if (response.status == "200") {
          toastMessage = {
            message: "Profile picture uploaded successfully",
            type: "success",
          };
          const imageUrl = URL.createObjectURL(file);
          setPreview(imageUrl);
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
        }
      } catch (err) {
        setPreview("/avatar.svg");
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = "";
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/onboarding/personal-information/upload/profile-image`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append("profile_image", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const startCamera = async () => {
    setShowCamera(true);

    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error("Camera access error:", err);
    }
  };
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);
  useEffect(() => {
    const allAccounts = members
      .filter(
        (m) => m?.firstName?.value && m?.lastName?.value && m?.email?.value,
      )
      .map((m) => ({
        value: m.email.value,
        label: `${m.firstName.value} ${m.lastName.value}`,
      }));
    allAccounts.push({
      value: "me",
      label: "Myself",
    });
    if (allAccounts.length) {
      setJointAccountUsersData(allAccounts);
      setJointAccountUsersData(allAccounts);

      // Reset preselected if not in the updated list
      const isPreselectedValid = allAccounts.some(
        (acc) => acc.value === preselectedJointAccountUser?.value,
      );
      const isPreselectedValidLabel = allAccounts.some(
        (acc) => acc.label === preselectedJointAccountUser?.label,
      );
      if (!isPreselectedValid || !isPreselectedValidLabel) {
        setPreselectedJointAccountUser({});
      }
    }
  }, [members]);
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          setfileAttorneyPath({
            ...fileAttorneyPath,
            value: response.data,
          });
          setFileAvailable(true);
        } else {
          setFileAvailable(false);
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setFileAvailable(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileAttorney], // Dependencies
  );
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");
    setPreview(dataUrl);
    // convert base64 -> file
    const file = dataURLtoFile(dataUrl, "snapshot.png");
    setCapturedFile(file); // store for API payload
    // cleanup
    //  handleCloseCamera();
  };
  // utility function to convert base64 -> File object
  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };
  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  const handleFileChangeAttorney = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAttorney(selectedFile);
        setLoading(true);
        handleUploadFileAttorney(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const transformMembers = async (members, payloadAddress) => {
    const transformed = await Promise.all(
      members.map(async (item, index) => {
        if (accountType == 4) {
          const addr = item.address.value.value;

          // 1️⃣ Fetch country, state, city IDs via API
          const locationdetails = await getLocation(
            addr.country,
            addr.state,
            addr.city,
          );

          // 2️⃣ Return transformed object
          return {
            first_name: item.firstName.value || "",
            last_name: item.lastName.value || "",
            email: item.email.value,
            country_code: item.countryCode.value,
            mobile_number: item.mobile.value,
            date_of_birth: item.dob.value,
            is_sole_signatory: jointAccountUser === item.email.value,
            power_of_attorney_url: "",
            address: {
              address_line_1: addr.street === "" ? addr.full : addr.street,
              address_line_2: addr.route,
              city_id: locationdetails.city_id || null,
              state_id: locationdetails.state_id || null,
              country_id: locationdetails.country_id || null,
              zip_code: addr.zip,
              google_address: addr.full,
            },
          };
        } else {
          // 2️⃣ Return transformed object
          return {
            first_name: item.firstName.value || "",
            last_name: item.lastName.value || "",
            email: item.email.value,
            country_code: item.countryCode.value,
            date_of_birth: item.dob.value,
            mobile_number: item.mobile.value,
            is_sole_signatory: jointAccountUser === item.email.value,
            power_of_attorney_url: "",
            address: payloadAddress,
          };
        }
      }),
    );

    return transformed;
  };

  const submitApplicationAPI = async (isFinal, payloadAddress) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;
    let apiUrl = isOnbaording
      ? isInvitee
        ? `${BASE_URL}/v1/onboarding/personal-information/invitee/submit`
        : isInviteeDirector
          ? `${BASE_URL}/v1/onboarding/corporate-director/personal-information/submit`
          : `${BASE_URL}/v1/onboarding/personal-information/individual/submit`
      : isInvitee
        ? `${BASE_URL}/v1/onboarding/personal-information/invitee/resubmit`
        : isInviteeDirector
          ? `${BASE_URL}/v1/onboarding/corporate-director/personal-information/resubmit`
          : `${BASE_URL}/v1/onboarding/personal-information/individual/update`;

    let transformed = [];

    if (
      !isInvitee &&
      !isInviteeDirector &&
      accountType != 1 &&
      accountType != 5
    ) {
      transformed = await transformMembers(members, payloadAddress);
    }
    let bodyData = {};
    if (!isInvitee && !isInviteeDirector) {
      bodyData = {
        account_type_id: accountType,
        full_name:
          firstName.value + " " + middleName.value + " " + lastName.value,
        first_name: firstName.value,
        last_name: lastName.value,

        profile_picture_file: {
          file_id: profilePayloadFile.value.file_id,
          file_name: profilePayloadFile.value.file_name,
        },
        is_birth_name: nameFromBirth.value,
        former_names: formerNames.value,
        date_of_birth: Dob.value,
        applicant_country_id: countryCode.value.id,
        address: payloadAddress,
        expected_investment_amount: investmentAmountText.value,
        default_currency_id: toCurrency.value.id,
        social_security_number: socialSecurityNumber.value,
        is_managing_member: isCheckedSecond,
        is_any_sole_signatory: signatory === "yes" ? true : false,
        is_sole_signatory: jointAccountUser == "me" ? true : false,
        joint_account_invitees: transformed,
        joint_user_account_id: jointAccountId,
        power_of_attorney_file:
          accountType == 2 || accountType == 3 || accountType == 4
            ? {
                file_id: fileAttorneyPath.value.file_id,
                file_name: fileAttorneyPath.value.file_name,
              }
            : null,
        is_submitted: isFinal,
      };
    }

    if (isInvitee || isInviteeDirector) {
      bodyData = {
        account_type_id: accountType,
        full_name:
          firstName.value + " " + middleName.value + " " + lastName.value,
        first_name: firstName.value,
        last_name: lastName.value,

        profile_picture_file: {
          file_id: profilePayloadFile.value.file_id,
          file_name: profilePayloadFile.value.file_name,
        },
        is_birth_name: nameFromBirth.value,
        former_names: formerNames.value,
        date_of_birth: Dob.value,
        applicant_country_id: countryCode.value.id,
        address: payloadAddress,
        expected_investment_amount: investmentAmountText.value,
        default_currency_id: toCurrency.value.id,
        social_security_number: socialSecurityNumber.value,
        is_submitted: isFinal,
      };
    }

    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? "POST" : "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/personal-information/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      let payloadAddress = {};
      if (apIAddress != null) {
        payloadAddress = {
          address_line_1:
            apIAddress.address_line_1 == null
              ? apIAddress.google_address
              : apIAddress.address_line_1,
          address_line_2:
            apIAddress.address_line_2 == null
              ? null
              : apIAddress.address_line_2,
          city_id: apIAddress.city != null ? apIAddress.city.id : null,
          state_id: apIAddress.city != null ? apIAddress.city.state_id : null,
          country_id: redCountry,
          zip_code: apIAddress.postal_code,
          google_address: apIAddress.google_address,
        };
      } else {
        payloadAddress = {
          address_line_1:
            redAddress.value.street == ""
              ? redAddress.value.full
              : redAddress.value.street,
          address_line_2: redAddress.value.route,
          city_id: redCity,
          state_id: redState,
          country_id: redCountry,
          zip_code: redAddress.value.zip,
          google_address: redAddress.value.full,
        };
      }
      if (payloadAddress.city_id === null) {
        showToast("Please select a valid city before proceeding.", "error");
        return; // Stop execution if city_id is missing
      }
      const response = await submitApplicationAPI(isFinal, payloadAddress);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(2);
          toastMessage = {
            message: response.message,
            type: "success",
          };
          const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  useEffect(() => {
    getAccountTypes();
    getInvestmentAmount();
    getAllCurrency();
    getAllCountries();
  }, []);
  useEffect(() => {
    if (
      expectedAmountData.length > 0 &&
      stepStatus.length > 0 &&
      stepStatus[0].status != "DRAFT"
    ) {
      getDetailsWithVerification();
    }
  }, [expectedAmountData, stepStatus]);
  useEffect(() => {
    if (
      (isInvitee || isInviteeDirector) &&
      stepStatus.length > 0 &&
      stepStatus[0].status == "DRAFT"
    ) {
      getPrefilled();
    }
  }, [isInvitee, isInviteeDirector, stepStatus]);
  useEffect(() => {
    if (
      updateFieldStatus &&
      stepStatus.length > 0 &&
      stepStatus[0].status != "DRAFT"
    ) {
      getDetailsWithVerification();
    }
  }, [stepStatus, updateFieldStatus]);
  useEffect(() => {
    if (
      (redAddress.value && redAddress.value.country) ||
      (redAddress.value && redAddress.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [redAddress]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {countryCode.value && countryCode.value.risk_factor == "high" && (
          <div className="mb-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
            <img src="/tick-error.svg" alt="Info" className="w-5 h-5 mr-2" />
            <span>
              It looks like we’re
              <strong> not able to accept applications</strong> from this
              country at the moment.{" "}
            </span>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == "IN_REVIEW" ||
            stepStatus[0].status == "COMPLETED") && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{" "}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{" "}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[0].status == "APPROVED" && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.PERSONAL_INFORMATION?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.PERSONAL_INFORMATION.rejected_fields.length === 1
                ? "The following field requires correction:"
                : "The following fields require correction:"}{" "}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.PERSONAL_INFORMATION.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, " ")}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/profile-circle-black.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Personal Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      {fieldLabelMap.account_type_id}
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={accountTypeData}
                  onSelect={handleSelectAccountType}
                  disabled={isInvitee || isInviteeDirector}
                  preselectedValue={preselectedAccountType}
                />
                {accountType != 1 && accountType != 5 && (
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                    Please make sure you have chosen the joint account type that
                    best fits you.
                  </p>
                )}
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col md:px-4">
              <div className="">
                <CustomDropdownWithFetch
                  label={
                    <>
                      {fieldLabelMap.applicant_country_id}
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={countryCodeData}
                  search={true}
                  preselectedValue={preselectedCountryCode}
                  onSelect={handleSelectCountryCode}
                  colorLabel=""
                  fetchOptions={getCountries} // <-- pass fetch function, not options
                />
              </div>
            </div>
          </div>
          {countryCode.value && countryCode.value.risk_factor != "high" && (
            <div className="bg-white">
              <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {/* Profile Picture Section */}
                <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                  <LabelWithStatus
                    id="profilePic"
                    label={fieldLabelMap.profile_picture_file}
                    required={true}
                    fieldData={profilePayloadFile}
                    handleStatusClick={handleStatusClick}
                  />
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-16 h-16 flex items-center justify-center">
                      <img
                        src={preview}
                        alt="Avatar"
                        className={`${
                          profilePayloadFile.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } w-14 h-14 rounded-full`}
                      />
                    </div>
                    <div className="flex flex-col space-y-1">
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                      <button
                        onClick={handleUploadClick}
                        disabled={profilePayloadFile.status == "approved"}
                        className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full"
                      >
                        Upload from Device
                      </button>
                      <button
                        onClick={() => {
                          setPreview("");
                          setProfilePayloadFile({
                            ...profilePayloadFile,
                            value: null,
                          });
                          setCapturedFile(null);
                          startCamera();
                        }}
                        disabled={profilePayloadFile.status == "approved"}
                        className="bg-black text-white text-xs px-3 py-1 rounded-full flex items-center justify-center gap-2"
                      >
                        <img
                          src="/camera-black.svg"
                          alt="Camera Icon"
                          className="w-4 h-4"
                        />
                        Take Snap
                      </button>
                    </div>
                  </div>
                  {/* Fullscreen Camera Modal */}
                  {showCamera && (
                    <div
                      className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${
                        animateCamera ? "opacity-100" : "opacity-0"
                      }`}
                    >
                      <div
                        className={`relative transform transition-transform duration-300 ease-in-out bg-white rounded-xl p-4 w-full max-w-md flex flex-col items-center ${
                          animateCamera ? "scale-100" : "scale-90"
                        }`}
                      >
                        {/* Preview or Live Camera */}
                        {preview === "" ? (
                          <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            className="w-full h-auto rounded shadow-lg"
                          />
                        ) : (
                          <div className="relative w-full">
                            <img
                              src={preview}
                              alt="Avatar"
                              className="w-full h-auto rounded shadow-lg"
                            />
                            <button
                              onClick={() => {
                                setPreview("");
                                setProfilePayloadFile({
                                  ...profilePayloadFile,
                                  value: null,
                                });
                                setCapturedFile(null);
                                startCamera();
                              }}
                              className="absolute top-2 right-2 bg-white hover:bg-gray-100 p-1 rounded-full shadow-md transition"
                              aria-label="Remove preview"
                            >
                              <img
                                src="/trash.svg"
                                alt="Delete"
                                className="w-4 h-4"
                              />
                            </button>
                          </div>
                        )}

                        {/* Action Buttons */}
                        <div className="flex flex-wrap justify-center gap-4 mt-4">
                          <button
                            onClick={() => {
                              if (preview == "") {
                                setPreview("/avatar.svg");
                              }
                              if (
                                preview != "" &&
                                profilePayloadFile.value == null
                              ) {
                                setPreview("/avatar.svg");
                              }
                              handleCloseCamera();
                            }}
                            className="bg-white text-black border-black border-2 text-sm px-4 py-2 rounded-full"
                          >
                            Cancel
                          </button>
                          {preview === "" && (
                            <>
                              <button
                                onClick={handleTakeSnap}
                                className="bg-black text-white text-sm px-4 py-2 rounded-full"
                              >
                                Capture Photo
                              </button>
                            </>
                          )}
                          {preview !== "" && (
                            <>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  handleUploadFile(e);
                                }}
                                className="bg-black text-white text-sm px-4 py-2 rounded-full"
                              >
                                Upload Photo
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <canvas ref={canvasRef} className="hidden" />
                  <div className="mt-4">
                    <LabelWithStatus
                      id="firstName"
                      label={fieldLabelMap.first_name}
                      required={true}
                      fieldData={firstName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      value={firstName.value}
                      placeholder="Your First Name"
                      disabled={
                        isInvitee ||
                        isInviteeDirector ||
                        firstName.status == "approved"
                      }
                      className={`${
                        firstName.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setfirstName({
                          ...firstName,
                          value: e.target.value,
                        })
                      }
                    />
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      First Name as per identification documentation
                    </p>
                  </div>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="lastName"
                      label={fieldLabelMap.last_name}
                      required={true}
                      fieldData={lastName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      disabled={
                        isInvitee ||
                        isInviteeDirector ||
                        lastName.status == "approved"
                      }
                      value={lastName.value}
                      placeholder="Your Last Name"
                      className={`${
                        lastName.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setLastName({
                          ...lastName,
                          value: e.target.value,
                        })
                      }
                    />
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      Last Name as per identification documentation
                    </p>
                  </div>{" "}
                  <div className="mt-4">
                    <LabelWithStatus
                      id="middleName"
                      label={fieldLabelMap.middle_name}
                      required={true}
                      fieldData={middleName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="middleName"
                      name="middleName"
                      type="text"
                      value={middleName.value}
                      placeholder="Your Middle Name"
                      disabled={middleName.status == "approved"}
                      className={`${
                        middleName.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setMiddleName({
                          ...middleName,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mt-4 flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                    <LabelWithStatus
                      id="birthName"
                      label={fieldLabelMap.is_birth_name}
                      required={true}
                      fieldData={nameFromBirth}
                      handleStatusClick={handleStatusClick}
                    />
                    {/* Radio Buttons */}
                    <div className="flex items-center gap-4">
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="birthName"
                          value={true}
                          checked={nameFromBirth.value == true}
                          onChange={handleNameFromBirth}
                          disabled={nameFromBirth.status == "approved"}
                          className={`${
                            nameFromBirth.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border-gray-300"
                          } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                        />
                        <span className="ml-2">Yes</span>
                      </label>

                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="birthName"
                          value={false}
                          checked={nameFromBirth.value == false}
                          onChange={handleNameFromBirth}
                          disabled={nameFromBirth.status == "approved"}
                          className={`${
                            nameFromBirth.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border-gray-300"
                          } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                        />
                        <span className="ml-2">No</span>
                      </label>
                    </div>
                  </div>
                  <div className="">
                    <LabelWithStatus
                      id="formerNames"
                      label={fieldLabelMap.former_names}
                      required={true}
                      fieldData={formerNames}
                      handleStatusClick={handleStatusClick}
                    />
                    <div
                      className={`${
                        formerNames.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border-gray-300"
                      } mt-1 border rounded-md  p-2 flex flex-wrap gap-2`}
                    >
                      {formerNames.value && formerNames.value.length > 0 && (
                        <>
                          {formerNames.value.map((formerName, index) => (
                            <div
                              key={index}
                              className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                            >
                              <span>{formerName}</span>
                              <button
                                type="button"
                                onClick={() => handleRemoveFormerName(index)}
                                className="ml-2 text-gray-700 hover:text-gray-700"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </>
                      )}

                      <input
                        type="text"
                        value={newFormerName}
                        onChange={(e) => setFormerName(e.target.value)}
                        onKeyDown={handleAddFormerName}
                        placeholder="Add name"
                        className="border-none focus:outline-none flex-grow text-sm"
                        disabled={formerNames.status == "approved"}
                      />
                    </div>
                  </div>
                </div>

                {/* Date of Birth Section */}
                <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                  <div>
                    <LabelWithStatus
                      id="Dob"
                      label={fieldLabelMap.date_of_birth}
                      required={true}
                      fieldData={Dob}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      type="date"
                      value={Dob.value}
                      onChange={(e) =>
                        setDob({
                          ...Dob,
                          value: e.target.value,
                        })
                      }
                      disabled={Dob.status == "approved"}
                      className={`${
                        Dob.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border-gray-300"
                      } block w-full p-2 text-black font-medium border rounded-md text-md`}
                    />
                  </div>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="expectedAmount"
                      label={fieldLabelMap.expected_investment_amount}
                      required={true}
                      fieldData={investmentAmountText}
                      handleStatusClick={handleStatusClick}
                    />
                    <Dropdown
                      label=""
                      options={expectedAmountData}
                      preselectedValue={preselectedInevstmentAmount}
                      onSelect={handleSelectInvestmentAmount}
                      disabled={investmentAmountText.status == "approved"}
                      parentClass={
                        investmentAmountText.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                    />
                  </div>

                  <div className="mt-4">
                    <LabelWithStatus
                      id="investmentCurrency"
                      label={fieldLabelMap.default_currency_id}
                      required={true}
                      fieldData={toCurrency}
                      handleStatusClick={handleStatusClick}
                    />
                    <Dropdown
                      label=""
                      options={currencyData}
                      search={true}
                      preselectedValue={preselectedcashCurrency}
                      onSelect={handleSelectToCurrency}
                      colorLabel=""
                      disabled={toCurrency.status == "approved"}
                      parentClass={
                        toCurrency.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                    />
                  </div>
                  {countryCode.value && countryCode.value.id == 233 && (
                    <div className="mt-4">
                      <LabelWithStatus
                        id="socialSecurityNumber"
                        label={fieldLabelMap.social_security_number}
                        required={true}
                        fieldData={socialSecurityNumber}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="socialSecurityNumber"
                        name="socialSecurityNumber"
                        type="text"
                        value={socialSecurityNumber.value}
                        placeholder="Your Social Security Number"
                        disabled={socialSecurityNumber.status == "approved"}
                        className={`${
                          socialSecurityNumber.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setSocialSecurityNumber({
                            ...socialSecurityNumber,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}
                </div>

                {/* Client ID Section */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Client ID
                  </label>
                  <input
                    id="refId"
                    type="text"
                    value={clientId}
                    disabled={true}
                    className="bg-[#F9F9F9] p-2 text-black font-medium rounded-md text-md"
                    placeholder="INV1947534324"
                  />
                  <div className="mt-4">
                    <LabelWithStatus
                      id="ResidentialAddress"
                      label={fieldLabelMap.address_id}
                      required={true}
                      fieldData={redAddress}
                      handleStatusClick={handleStatusClick}
                    />
                    <AddressAutocomplete
                      value={
                        redAddress?.value?.full ||
                        apIAddress?.google_address ||
                        ""
                      }
                      disabled={
                        ((isInvitee || isInviteeDirector) &&
                          accountType != 4) ||
                        redAddress.status == "approved"
                      }
                      className={
                        redAddress.status == "rejected"
                          ? "border-[#FF5050] border-2 w-full"
                          : "w-full"
                      }
                      onSelect={(addr) => {
                        setApIAddress(null);
                        setRedAddress({
                          ...redAddress,
                          value: addr,
                        });
                      }}
                    />
                  </div>
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                    PLEASE MAKE SURE THE PROVIDED ADDRESS MATCHES THE DOCUMENT
                    PROOFS YOU PROVIDE.
                  </p>

                  {!isInvitee &&
                    !isInviteeDirector &&
                    accountType != 1 &&
                    accountType != 5 && (
                      <>
                        <div className="mt-4">
                          <label
                            htmlFor="jAccId"
                            className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                          >
                            Joint Account ID
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            id="jAccId"
                            name="jAccId"
                            type="text"
                            value={jointAccountId}
                            disabled={true}
                            placeholder="Joint Account Id"
                            className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          />
                        </div>
                        <div className="flex flex-col items-start mt-2 w-full max-w-md mx-auto ">
                          <div className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              id="confirm-all"
                              className="border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                              checked={isCheckedSecond}
                              onChange={(e) =>
                                setIsCheckedSecond(e.target.checked)
                              }
                            />
                            <label
                              htmlFor="confirm-all"
                              className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                            >
                              Managing Member.
                            </label>
                          </div>
                          <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                            By clicking on this you agree to be contacted to
                            manage the account
                          </p>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
        {countryCode.value &&
          countryCode.value.risk_factor != "high" &&
          !isInvitee &&
          !isInviteeDirector &&
          accountType != 1 &&
          accountType != 5 && (
            <div className="bg-white shadow-md rounded-md p-4 mt-4">
              {" "}
              <div className="flex justify-between font-medium items-center mb-4">
                <div className="flex flex-col">
                  <h2 className="text-lg">Invite Joint Account Members</h2>
                  {(members.length === 0 ||
                    (members.length > 0 &&
                      members[0].firstName.value === "" &&
                      members[0].lastName.value === "" &&
                      members[0].email.value === "")) && (
                    <div className="flex items-center space-x-1">
                      <img
                        src="/danger.svg"
                        alt="User Icon"
                        className="w-4 h-4"
                      />
                      <span className="text-xs ml-2 font-medium text-[#FF5050]">
                        It is mandatory to provide at least one invitee to the
                        Joint Account.
                      </span>
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-sm text-labelColour">
                    No of Joint Account Member:{" "}
                  </span>
                  <span className="text-sm text-black">
                    {members.length.toString().padStart(2, "0")}
                  </span>
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                  {/* Table Head */}
                  <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                    <tr>
                      <th className="p-2 w-[40px]"></th>
                      <th className="p-2">First Name</th>
                      <th className="p-2">Last Name</th>
                      <th className="p-2">Date of Birth</th>
                      <th className="p-2">Email Address</th>
                      <th className="p-2">Mobile Number</th>
                      {accountType == 4 && (
                        <th className="p-2">Residential Address</th>
                      )}
                      {(accountType == 2 ||
                        accountType == 3 ||
                        accountType == 4) && (
                        <th className="p-2">Account Type</th>
                      )}
                      <th className="p-2 w-[40px]"></th>
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {members.map((member, idx) => (
                      <tr key={idx} className="border-t bg-white align-top">
                        {/* Index */}
                        <td className="p-2 font-medium text-labelColour">
                          {(idx + 1).toString().padStart(2, "0")}.
                        </td>

                        {/* First Name */}

                        <td className="p-2">
                          <div className="flex items-center space-x-2 w-full">
                            <input
                              className="border p-2 rounded-xl text-sm flex-1"
                              placeholder="First Name"
                              value={member.firstName.value}
                              onChange={(e) =>
                                updateMember(idx, "firstName", e.target.value)
                              }
                            />
                            {member.firstName?.comments?.length > 0 && (
                              <StatusButton
                                status={member.firstName.status}
                                count={member.firstName.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    member.firstName,
                                    "First Name",
                                    member.firstName.value,
                                  )
                                }
                              />
                            )}
                          </div>
                        </td>

                        <td className="p-2">
                          <div className="flex items-center space-x-2 w-full">
                            <input
                              className="border p-2 rounded-xl text-sm flex-1"
                              placeholder="Last Name"
                              value={member.lastName.value}
                              onChange={(e) =>
                                updateMember(idx, "lastName", e.target.value)
                              }
                            />
                            {member.lastName?.comments?.length > 0 && (
                              <StatusButton
                                status={member.lastName.status}
                                count={member.lastName.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    member.lastName,
                                    "Last Name",
                                    member.lastName.value,
                                  )
                                }
                              />
                            )}
                          </div>
                        </td>
                        {/* DOB */}
                        <td className="p-2">
                          <div className="flex items-center space-x-2 w-full">
                            <input
                              type="date"
                              className="border p-2 rounded-xl text-sm flex-1"
                              placeholder="Date of Birth"
                              value={member.dob.value}
                              onChange={(e) =>
                                updateMember(idx, "dob", e.target.value)
                              }
                            />
                            {member.dob?.comments?.length > 0 && (
                              <StatusButton
                                status={member.dob.status}
                                count={member.dob.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    member.dob,
                                    "Date of birth",
                                    member.dob.value,
                                  )
                                }
                              />
                            )}
                          </div>
                        </td>

                        {/* Email */}
                        <td className="p-2">
                          <div className="flex items-center space-x-2 w-full">
                            <div className="flex flex-col">
                              <input
                                className={`border  p-2 rounded-xl text-sm flex-1 ${
                                  member.errors?.email ? "border-red-500" : ""
                                }`}
                                type="email"
                                placeholder="Email"
                                value={member.email.value}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const isValid =
                                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                                  updateMember(idx, "email", value, {
                                    ...member.errors,
                                    email:
                                      isValid || value === ""
                                        ? ""
                                        : "Invalid email address",
                                  });
                                }}
                              />
                              {member.errors?.email && (
                                <span className="text-red-500 text-xs mt-1">
                                  {member.errors.email}
                                </span>
                              )}
                            </div>
                            {member.email?.comments?.length > 0 && (
                              <StatusButton
                                status={member.email.status}
                                count={member.email.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    member.email,
                                    "Email",
                                    member.email.value,
                                  )
                                }
                              />
                            )}
                          </div>
                        </td>

                        {/* Mobile */}
                        <td className="p-2">
                          <div className="flex items-center space-x-2 w-full">
                            <div className="flex flex-col">
                              <div className="flex items-center border rounded-xl overflow-hidden">
                                <select
                                  className=" px-2 text-sm text-[#888888] font-medium bg-transparent outline-none"
                                  value={member.countryCode.value}
                                  onChange={(e) =>
                                    updateMember(
                                      idx,
                                      "countryCode",
                                      e.target.value,
                                    )
                                  }
                                >
                                  {" "}
                                  {countries.map((c) => (
                                    <option
                                      className=""
                                      key={c.code}
                                      value={c.dialCode}
                                    >
                                      {" "}
                                      {c.code} ({c.dialCode}){" "}
                                    </option>
                                  ))}{" "}
                                </select>
                                <input
                                  className={`outline-none p-2 text-sm flex-1 ${
                                    member.errors?.mobile
                                      ? "border-red-500"
                                      : ""
                                  }`}
                                  placeholder="Mobile"
                                  value={member.mobile.value}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const isValid = /^[0-9]{9}$/.test(value);
                                    updateMember(idx, "mobile", value, {
                                      ...member.errors,
                                      mobile:
                                        isValid || value === ""
                                          ? ""
                                          : "Enter a valid 9-digit number",
                                    });
                                  }}
                                />
                              </div>
                              {member.errors?.mobile && (
                                <span className="text-red-500 text-xs mt-1">
                                  {member.errors.mobile}
                                </span>
                              )}
                            </div>
                            {member.mobile?.comments?.length > 0 && (
                              <StatusButton
                                status={member.mobile.status}
                                count={member.mobile.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    member.mobile,
                                    "Mobile number",
                                    member.countryCode.value +
                                      member.mobile.value,
                                    "",
                                  )
                                }
                              />
                            )}
                          </div>
                        </td>

                        {accountType == 4 && (
                          <td className="p-2">
                            <div className="flex items-center space-x-2 w-full">
                              <div className="flex flex-col">
                                <AddressAutocomplete
                                  className="flex-1"
                                  value={member.address?.full || ""}
                                  onSelect={(addr) => {
                                    updateMember(idx, "address", {
                                      ...member.address,
                                      value: addr,
                                    });
                                  }}
                                />
                                {member.errors?.address && (
                                  <span className="text-red-500 text-xs mt-1">
                                    {member.errors.address}
                                  </span>
                                )}
                              </div>
                              {member.address?.comments?.length > 0 && (
                                <StatusButton
                                  status={member.address.status}
                                  count={member.address.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      member.address,
                                      "Address",
                                      member.address.value,
                                    )
                                  }
                                />
                              )}
                            </div>
                          </td>
                        )}
                        {(accountType == 2 ||
                          accountType == 3 ||
                          accountType == 4) && (
                          <td className="p-2">
                            <div className="flex flex-col relative w-full">
                              <div className="mt-1 relative">
                                <select
                                  className="flex-1 border pr-6 p-2 rounded-xl text-sm focus:outline-none bg-white appearance-none"
                                  value={member.accountType.value}
                                  onChange={(e) =>
                                    updateMember(
                                      idx,
                                      "accountType",
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="individual">Individual</option>
                                  <option value="corporate">Corporate</option>
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-1 flex items-center">
                                  <svg
                                    className="h-4 w-4 text-black"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10 12a1 1 0 01-.7-.3l-3-3a1 1 0 111.4-1.4L10 9.6l2.3-2.3a1 1 0 011.4 1.4l-3 3a1 1 0 01-.7.3z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                              {member.errors?.accountType && (
                                <span className="text-red-500 text-xs mt-1">
                                  {member.errors.accountType}
                                </span>
                              )}
                            </div>
                          </td>
                        )}
                        {/* Delete */}
                        <td className="p-2  text-center">
                          <button
                            onClick={() => removeMember(idx)}
                            title="Remove"
                            className="text-red-500"
                          >
                            <img
                              src="/trash.svg"
                              alt="Delete"
                              className="h-5 w-5 mt-4"
                            />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-center mt-4 w-full">
                <button
                  onClick={addMember}
                  className="text-[#005A9C] bg-white rounded-xl px-4 py-2 border-dashed border-2 text-sm"
                >
                  + Add Joint Account Member
                </button>
              </div>
              {isUserPopOpen && (
                <AddUserPopup
                  setactualData={setactualData}
                  onClose={() => setisUserPopOpen(false)}
                />
              )}
              {members.length > 0 &&
                members[0].firstName.value !== "" &&
                members[0].lastName.value !== "" &&
                members[0].email.value !== "" && (
                  <div className="mt-4 border-t grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col px-2 md:pl-4 md:pr-0 pt-4">
                      {/* Label and Question */}
                      <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                        <label
                          htmlFor="investmentType"
                          className="block text-sm text-labelColour whitespace-normal break-words"
                        >
                          Is there going to be a Sole Signatory by providing a
                          Power Of Attorney?
                          <span className="text-red-500">*</span>
                        </label>

                        {/* Radio Buttons */}
                        <div className="flex items-center gap-4">
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value="yes"
                              checked={signatory === "yes"}
                              onChange={(e) => setSignatory(e.target.value)}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">Yes</span>
                          </label>

                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value="no"
                              checked={signatory === "no"}
                              onChange={(e) => setSignatory(e.target.value)}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelLightColour whitespace-normal break-words"
                        >
                          All the Joint Account members will be considered as
                          Signatories
                        </label>
                      </div>
                    </div>
                    {signatory == "yes" && (
                      <>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-2">
                          <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                            <div className="mb-2">
                              <Dropdown
                                label={
                                  <>
                                    Select which joint account member is going
                                    to be the sole signatory
                                    <span className="text-red-500"> *</span>
                                  </>
                                }
                                options={jointAccountUsersData}
                                preselectedValue={preselectedJointAccountUser}
                                onSelect={handleSelectJointAccountUser}
                              />
                            </div>{" "}
                          </div>
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col px-2">
                          <LabelWithStatus
                            id="fileAttorneyPath"
                            label={fieldLabelMap.power_of_attorney_file}
                            required={true}
                            fieldData={fileAttorneyPath}
                            handleStatusClick={handleStatusClick}
                          />
                          {/* Drag & Drop Upload Area */}
                          <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                            <input
                              type="file"
                              id="fileUpload"
                              accept=".pdf,.png,.jpeg"
                              onChange={handleFileChangeAttorney}
                              className="hidden"
                              disabled={fileAttorneyPath.status == "approved"}
                            />
                            <img
                              src="/folder-add.svg"
                              alt="Success Icon"
                              className="h-4 w-4"
                            />{" "}
                            <p
                              disabled={fileAttorneyPath.status == "approved"}
                              className="mt-2 text-gray-500 text-sm"
                            >
                              Drag & Drop <br />
                              or{" "}
                              <span className="underline">Click to Upload</span>
                            </p>
                          </label>
                          <div className="mt-1">
                            <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              PNG
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              JPEG
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              PDF
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              &#60; 10 MB
                            </span>
                          </div>

                          {((fileAttorney && fileAvailable) ||
                            fileAttorneyPath.value) && (
                            <div
                              className={`${
                                fileAttorneyPath.status == "rejected"
                                  ? "border-[#FF5050] border-2"
                                  : "border"
                              }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                            >
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(e, fileAttorneyPath.value);
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileAttorneyPath.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              {fileAttorneyPath.status != "approved" && (
                                <button
                                  onClick={handleDeleteFile}
                                  className="text-red-500 flex-shrink-0 font-semibold"
                                >
                                  <img
                                    src="/trash.svg"
                                    alt="Delete Icon"
                                    className="h-4 w-4 flex-shrink-0"
                                  />
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
          )}
      </div>
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {countryCode.value && countryCode.value.risk_factor != "high" && (
        <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
          {stepStatus.length > 0 &&
            stepStatus[0].status != "COMPLETED" &&
            stepStatus[0].status != "APPROVED" &&
            stepStatus[0].status != "IN_REVIEW" && (
              <>
                <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                  <ConfirmResetButton
                    onConfirm={handleReset}
                    isReset={true}
                    isBack={false}
                    onBack={handleBack}
                  />
                </div>
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>

                  <ConfirmContinueButton
                    onContinue={() => handleContinue(true)}
                    buttonText="Continue"
                    confirmTitle="Save Section"
                    confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                  />
                </div>
              </>
            )}
          {stepStatus.length > 0 &&
            (stepStatus[0].status == "COMPLETED" ||
              stepStatus[0].status == "APPROVED" ||
              stepStatus[0].status == "IN_REVIEW") && (
              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(2);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            )}
        </footer>
      )}
    </div>
  );
};

export default PersonalInfo;
